import React, { Children, useEffect } from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useMeasure } from 'react-use';


export const FullWidth = (props) => {
    //sm xs={{ span: 12, order: 'last' }} md={{ span: 6, order: 'first' }} xl={4} className="d-flex justify-content-center"

    //const getClass = () => {
    //    return props.isBoardEnabled ? "order-last order-md-first col-md-6 col-xl-4 d-flex justify-content-center" : "";
    //}

    const direction = props.contentDirection ? `flex-${props.contentDirection}` : "flex-column";
    const className = `d-flex ${direction} justify-content-center align-items-center justify-content-sm-start py-2 py-md-4 flex-grow-1 gap-4`
    const [ref, bounds] = useMeasure();

    return (
        <Col className="d-flex justify-content-center">

            <div ref={ref} className={className}>
                {props.title &&
                    <div className="d-flex">
                        <div className="d-flex justify-content-center align-items-center feature-title">
                            <h4>{props.title}</h4>
                        </div>
                    </div>
                }

                {React.Children.map(props.children, child => React.cloneElement(child, { parent: { bounds } }))}
            </div>
        </Col>

    )
}
